import React, { useEffect, useMemo, useRef, useState } from 'react'
import { GlobalSettingsDetails } from './website/services/website.services';
import { useDispatch } from 'react-redux';
import { addData } from '../redux/slices/globalDetails';
import { Outlet, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { scheduleOfflineImageLoad } from './website/helpers/offlineImage';
import { SOCKET_CLIENT } from '../utils/socket';
import { SOCKET_CLIENT_EVENTS, SOCKET_EVENTS } from '../utils/Constants';

export default function GlobalLayout() {
    const offlineModalOpen = useRef();
    const offlineModalClose = useRef();
    const navigate = useNavigate();
    window.navigate_ = navigate;
    const dispatch = useDispatch();
    const [offlineImg, setOfflineImg] = useState(null);
    const {t}= useTranslation();

    useMemo(() => {
        GlobalSettingsDetails().then(async (globalDetails) => {
            dispatch(addData(JSON.stringify(globalDetails?.data)));
        });
    }, []);
    const isNetworkConnected = async () => {
        fetch('https://www.google.com/')
          .then(response => {
            if (response.ok) {
                offlineModalClose.current?.click();
            }
          })
          .catch(error => {
            return false;
          });
      };

      const handleOnline = () => {
        offlineModalClose.current?.click();
      };
      const handleOffline = () => {
        offlineModalOpen.current?.click();
      };
      useEffect(() => {    
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);
    
        return () => {
          window.removeEventListener("online", handleOnline);
          window.removeEventListener("offline", handleOffline);
        };
      }, []);

      useEffect(() => {
        return scheduleOfflineImageLoad(setOfflineImg);
      }, []);

      // WRDS-769 maintenance overlay — root-level runtime-config listener.
      // Server broadcasts RUNTIME_CONFIG on every flip AND pushes it to each
      // new socket connection, so a tab opened mid-maintenance also sees it.
      // A backend-only flip still overlays the web (the API is unusable).
      const [maintenance, setMaintenance] = useState(null);
      useEffect(() => {
        const onSocketData = (payload) => {
          if (payload?.event !== SOCKET_EVENTS.RUNTIME_CONFIG) return;
          const m = payload?.data?.maintenance;
          setMaintenance(m && (m.frontend === true || m.backend === true) ? { message: m.message || '' } : null);
        };
        // Belt-and-braces: axios fires this on any 503 {maintenance:true} API
        // response (covers clients that missed the socket broadcast).
        const onApiMaintenance = (e) => setMaintenance({ message: e?.detail?.message || '' });
        SOCKET_CLIENT.on(SOCKET_CLIENT_EVENTS.GET_DATA, onSocketData);
        window.addEventListener('wilreji:maintenance', onApiMaintenance);
        return () => {
          SOCKET_CLIENT.off(SOCKET_CLIENT_EVENTS.GET_DATA, onSocketData);
          window.removeEventListener('wilreji:maintenance', onApiMaintenance);
        };
      }, []);
  return <>
  <Outlet/>

  {maintenance ? (
    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white" style={{ zIndex: 20000 }}>
      <div className="text-center px-4">
        <h3 className="fs-22">{t('label_maintenance_title', 'System under maintenance')}</h3>
        <p>{maintenance.message || t('label_maintenance_text', 'We are performing maintenance. Please try again shortly.')}</p>
      </div>
    </div>
  ) : null}

<button type="button" ref={offlineModalOpen} className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
 
</button>


<div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered modal-lg">
    <div className="modal-content offline-modal-content">
    <button type="button" className="btn-close d-none" ref={offlineModalClose} data-bs-dismiss="modal" aria-label="Close"></button>
      <div className="modal-body">
        <div className="w-100 d-flex justify-content-center py-5">
            <div className='text-center'>
                {offlineImg ? <img className='offline-modal-img' src={offlineImg} alt={t('label_offline_image')} /> : null}
                <h3 className='fs-22'>{t('label_no_internet')}</h3>
                <p>{t('label_check_internet_text')}</p>
                <button onClick={isNetworkConnected} className='btn btn-primary mt-2'>{t('btn_retry')}</button>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
  </>
}
